import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { TextSkeleton } from '../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { subscriptionSubscriptionHistoryTableHead } from '../../SubscriptionHistoryHeader/constants';

export const SubscriptionHistoryListItemLoadingDesktop: React.FC = () => {
  const getFlex = (index: number) => {
    const currentHead = subscriptionSubscriptionHistoryTableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" h="80px">
      <LateralBar
        backgroundColor="product.rendavariavel"
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TextSkeleton />
      </TableContentItemColumn>
    </TableContent>
  );
};
